import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { AmazonS3LinkedService } from './amazon-s3.linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.sapDatasphereForAmazonS3LinkedService,
    display: [
        format(
            shellStringResources.ModelName_LinkedServiceTemplate,
            shellStringResources.SapDatasphereForAmazonS3LinkedService_DisplayText
        ),
        format(
            shellStringResources.ModelName_LinkedServicesTemplate,
            shellStringResources.SapDatasphereForAmazonS3LinkedService_DisplayText
        )
    ]
})
export class SapDatasphereForAmazons3LinkedService extends AmazonS3LinkedService {
    public static readonly MODEL: IModel;
}
